import { Landmark } from "@mediapipe/tasks-vision";

export const transformfaceLandmarks = (landmarks: Landmark[]) => {
  if (!landmarks) {
    return landmarks;
  }

  let minZ = Math.max(-landmarks[234].z, -landmarks[454].z);
 
  return landmarks.map(landmark => {
    let {x, y, z} = landmark;
    return {
      x: -0.5 + x,
      y: 0.5 - y,
      z: -z - minZ,
      visibility: landmark.visibility,
    }
  });
}

export const transformPoseLandmarks = (landmarks: Landmark[]) => {
  if (!landmarks) {
    return landmarks;
  }

  return landmarks.map(landmark => {
    let {x, y, z} = landmark;
    return {
      x: -0.5 + x,
      y: 0.5 - y,
      z: -z,
      visibility: landmark.visibility,
    }
  });
}

export const scaleLandmark = (landmark: Landmark, width: number, height: number) => {
  let { x, y, z } = landmark;
  return {
    ...landmark,
    x: x * width,
    y: y * height,
    z: z * width,
  };
};

export const addToBuffer = (buffer: any[], value: any, maxBufferSize: number) => {
  if (buffer.length >= maxBufferSize) {
    buffer.shift();
  }
  buffer.push(value);
};

export const calculateAverage = (buffer: any[]) => {
  if (buffer.length === 0) return [0, 0, 0];
  return buffer[0].map((_: number, i: number) =>
    buffer.reduce((sum, value) => sum + value[i], 0) / buffer.length
  );
};